// ДАТЫ ТУРА.
//
// В базе даты лежат строками ISO («2026-11-18»), но админка не запрещает
// вписать что угодно — например «конец ноября». Поэтому всё, что не разбирается
// как дата, показываем как есть: лучше сырая строка менеджера, чем «Invalid Date».

const LOCALES = { ru: "ru-RU", kk: "kk-KZ", en: "en-US" };

const parse = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const fmt = (date, lang, options) =>
  new Intl.DateTimeFormat(LOCALES[lang] || LOCALES.en, options).format(date);

/*
  ДИАПАЗОН ДАТ РАЗНЫЕ ЯЗЫКИ ПИШУТ ПО-РАЗНОМУ.

  Раньше диапазон внутри одного месяца склеивался вручную: «день от» + тире +
  дата до. По-русски получалось верно («18–25 нояб.»), потому что в русском
  день идёт перед месяцем. По-английски та же склейка давала «18–Nov 25»:
  число от начала диапазона повисало перед месяцем второй даты.

  Intl.DateTimeFormat.formatRange знает правила каждого языка и сам решает,
  что сокращать: en-US → «Nov 18 – 25», ru-RU → «18–25 нояб.». Ручная склейка
  осталась запасным вариантом для старых браузеров (Safari до 14.1),
  где formatRange ещё нет.
*/
const range = (from, to, lang, options, fallback) => {
  const formatter = new Intl.DateTimeFormat(LOCALES[lang] || LOCALES.en, options);
  if (typeof formatter.formatRange === "function") {
    try {
      return formatter.formatRange(from, to);
    } catch {
      // formatRange бросает исключение, если даты идут в обратном порядке
    }
  }
  return fallback();
};

// «18–25 ноября 2026», «23 окт. – 2 нояб. 2026»
export const formatDateRange = (start, end, lang = "ru") => {
  const from = parse(start);
  const to = parse(end);

  // Не разобрали — отдаём то, что вписал менеджер.
  if (!from) return start || "";

  const full = { day: "numeric", month: "long", year: "numeric" };

  if (!to || to.getTime() === from.getTime()) return fmt(from, lang, full);

  // Один месяц: «18–25 ноября 2026» / «Nov 18 – 25, 2026»
  if (from.getFullYear() === to.getFullYear() && from.getMonth() === to.getMonth()) {
    return range(from, to, lang, full, () => `${fmt(from, lang, { day: "numeric" })} – ${fmt(to, lang, full)}`);
  }

  // Разные месяцы: короткий месяц с обеих сторон — «23 окт. – 2 нояб. 2026»
  const short = { day: "numeric", month: "short" };
  const sameYear = from.getFullYear() === to.getFullYear();
  const opts = sameYear ? { ...short, year: "numeric" } : { ...full, month: "short" };
  return range(from, to, lang, opts, () => `${fmt(from, lang, short)} – ${fmt(to, lang, opts)}`);
};

// Короткая форма для карточки тура: «18–25 ноя»
export const formatDateRangeShort = (start, end, lang = "ru") => {
  const from = parse(start);
  const to = parse(end);
  if (!from) return start || "";

  const short = { day: "numeric", month: "short" };
  if (!to || to.getTime() === from.getTime()) return fmt(from, lang, short);

  return range(from, to, lang, short, () => `${fmt(from, lang, short)} – ${fmt(to, lang, short)}`);
};
